import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '../ui';
import { BadgeAlert, CircleHelp, Drama, EllipsisVertical, User } from 'lucide-react';
import { useRequestEditVerificationState } from '@/hooks/httpRequest';
import { useFormCommentReview } from '@/hooks/forms';
import { notifyInternalMessage } from '@/functions';
import { Button } from '@/components/ui/button.tsx';
import { VerificationStateEnum } from '@/enums';

type TProps = {
	verificationId: string;
	onAction?: () => void;
	onError?: () => void;
}

const ButtonChangeVerificationState = ({ verificationId, onAction, onError }: TProps) => {

	const { triggerEditVerificationState } = useRequestEditVerificationState({ disableInvalidateQueries: true });
	const { comment } = useFormCommentReview();

	const applyVerificationAction = (state: VerificationStateEnum, comment?: string) => {
		onAction?.();
		triggerEditVerificationState({ state, comment, verificationId })
			.catch(e => { notifyInternalMessage(e); onError?.(); });
	};

	const handleOnClickBtnOthers = () =>
		comment({
			onSubmit: (state, comment) => {
				onAction?.();
				return triggerEditVerificationState({ verificationId, comment, state })
					.catch(e => { notifyInternalMessage(e); onError?.(); }) as any;
			}
		});

	return (
		<DropdownMenu modal={false}>
			<DropdownMenuTrigger asChild>
				<Button
					type='button'
					size={'icon'}
					variant='secondary'>
					<EllipsisVertical />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className='w-56' align='end' side='top'>
				<DropdownMenuGroup>
					<DropdownMenuItem
						onClick={() => applyVerificationAction(VerificationStateEnum.SCAM)}
						className='cursor-pointer'>
						<Drama />
						<span>
							Arnaque
						</span>
					</DropdownMenuItem>
					<DropdownMenuItem
						onClick={() => applyVerificationAction(VerificationStateEnum.WHITE_PERSON)}
						className='cursor-pointer'>
						<User />
						<span>
							Blanc
						</span>
					</DropdownMenuItem>
					<DropdownMenuItem
						onClick={() => applyVerificationAction(VerificationStateEnum.CERTIFICATION_ERROR)}
						className='cursor-pointer'>
						<BadgeAlert />
						<span>
							Erreur de certification
						</span>
					</DropdownMenuItem>
					<DropdownMenuItem
						onClick={handleOnClickBtnOthers}
						className='cursor-pointer'>
						<CircleHelp />
						<span>
							Refuser avec raison
						</span>
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);

};

export default ButtonChangeVerificationState;
